/** Patient-facing condition label — strips test-data hex suffixes from display names. */
export function cleanConditionDisplay(display: string): string {
  const trimmed = display.trim();
  const cleaned = trimmed.replace(/\s+[a-f0-9]{6}$/i, "").trim();
  return cleaned || trimmed;
}
